<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          NO：{{
            formData.evgCombineNo
              ? formData.evgCombineNo
              : $l('title_status_created') || '新增'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          class="mr-2"
          style="font-size: 12px"
          :variant="
            formData.evgCombineStatus === 'Y'
              ? 'success'
              : formData.evgCombineStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{
            formData.evgCombineStatusText ||
              $l('title_status_planning') ||
              '企划'
          }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="spuForm"
      size="mini"
      :model="formData"
      :disabled="disabled"
      :rules="rules"
    >
      <el-row :gutter="10">
        <div class="mr-3">
          <el-image
            style="width: 130px; height: 130px;"
            fit="scale-down"
            :src="formData.defaultImageUrl"
            :preview-src-list="[
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic.jpg',
            ]"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic-square.jpg"
                style="width: 130px; height: 130px;"
              />
            </div>
          </el-image>
        </div>
        <el-col :span="22">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_combineName') || '中文名称'"
                prop="combineName"
              >
                <el-input
                  v-model="formData.combineName"
                  :placeholder="
                    $l('tips_input_combineName_placeholder') ||
                      '请输入中文名称...'
                  "
                  clearable
                  maxlength="200"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_combineNameEn') || '英文名称'"
                prop="combineNameEn"
              >
                <el-input
                  v-model="formData.combineNameEn"
                  :placeholder="
                    $l('tips_input_combineNameEn_placeholder') ||
                      '请输入英文名称...'
                  "
                  clearable
                  maxlength="200"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_cust') || '客户'"
                prop="custCode"
              >
                <dict-select
                  v-model="formData.custCode"
                  url="/ecom/ecom/evg/spu/customerFormalSelect"
                  :placeholder="
                    $l('tips_select_cust_placeholder') || '请选择客户'
                  "
                  :disabled="disabled"
                  @change="changeCustCode"
                  filterable
                  clearable
                  size="mini"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_brand') || '品牌'"
                prop="brandCode"
              >
                <el-select
                  v-model="formData.brandCode"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                  :disabled="disabled"
                  @change="onChangeBrand"
                  :placeholder="$l('tips_select_brand_data') || '请选择品牌...'"
                >
                  <el-option
                    v-for="item in brandOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_category') || '品类'"
                prop="categoryCode"
              >
                <CategoryCascader
                  :categoryCode.sync="formData.categoryCode"
                  :categoryName.sync="formData.categoryName"
                  :masterCategoryCode.sync="formData.masterCategoryCode"
                  :masterCategoryName.sync="formData.masterCategoryName"
                  :displayCategoryCode.sync="formData.displayCategoryCode"
                  :displayCategoryName.sync="formData.displayCategoryName"
                  :disabled="disabled"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-form-item :label="''" class="mr-3">
          <div style="width:130px"></div>
        </el-form-item>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_combinePattern') || '花型'"
            prop="combinePattern"
          >
            <el-input
              v-model="formData.combinePattern"
              :placeholder="
                $l('tips_input_combinePattern_placeholder') || '请输入花型'
              "
              clearable
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_combineColorCode') || '颜色'"
            prop="combineColorCode"
          >
            <el-select
              v-model="formData.combineColorCode"
              collapse-tags
              size="mini"
              style="width:100%"
              :placeholder="$l('tips_select_combineColor_data') || '请选择颜色'"
              clearable
              filterable
              @change="colorChange"
            >
              <el-option
                v-for="item in colorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                class="brand-select"
              >
                <div style="float: left">
                  <span class="brand-select-item">{{ item.label }}</span>
                  <span
                    class="brand-select-item"
                    style="color: #8492a6; font-size: 13px"
                    >{{ item.brandName }}</span
                  >
                </div>
                <span
                  v-if="item.colorCard"
                  class="colorCard"
                  :style="{ background: item.colorCard }"
                />
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_combineColor') || '中文颜色'"
            prop="combineColor"
          >
            <el-input
              v-model="formData.combineColor"
              clearable
              maxlength="50"
              :placeholder="$l('tips_select_combineColor_data') || '请选择颜色'"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_combineColorEn') || '英文颜色'"
            prop="combineColorEn"
          >
            <el-input
              v-model="formData.combineColorEn"
              clearable
              maxlength="50"
              :placeholder="$l('tips_select_combineColor_data') || '请选择颜色'"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-form-item :label="''" class="mr-3">
          <div style="width:130px"></div>
        </el-form-item>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_sku_goods_size') || '产品尺寸'"
            prop="combineSize"
          >
            <el-input
              v-model="formData.combineSize"
              :placeholder="
                $l('tips_input_goods_size_placeholder') || '请输入产品尺寸'
              "
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_eanCode') || 'EAN条码'">
            <el-input
              v-model="formData.eanCode"
              clearable
              maxlength="50"
              :placeholder="
                $l('tips_input_eanCode_placeholder') || '请输入EAN条码'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_ftyPrice') || '工厂单价'">
            <el-input v-model="formData.ftyPrice" clearable readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row class="mt-1">
        <el-col :span="24">
          <SkuTable
            :tableData="formData.ecomEvgCombinSkuList"
            :disabled="disabled"
            ref="skuTable"
            @delRow="delRow"
            @updateFormData="updateFormData"
            @updateFtyPrice="updateFtyPrice"
          >
            <template v-slot:header>
              <div class="d-flex mt-1">
                <div class="side-frame-success"></div>
                <div>
                  <span style="font-size: 14px; color: #606266">
                    {{ $l('form_label_product_composition') || '组合产品构成' }}
                  </span>
                  <el-divider
                    direction="vertical"
                    v-if="!disabled"
                  ></el-divider>
                  <el-button
                    size="mini"
                    type="primary"
                    plain
                    v-if="!disabled"
                    @click="chooseEvgSkuVisible = true"
                  >
                    {{ $l('form_label_choose_sku') || '选择SKU产品' }}
                  </el-button>
                </div>
              </div>
            </template>
          </SkuTable>
        </el-col>
      </el-row>
      <el-row class="mt-3" v-if="!disabled">
        <el-col :span="24">
          <div class="d-flex justify-content-end">
            <el-button type="primary" size="small" @click="save()">
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <ChooseEvgSku
      :visible.sync="chooseEvgSkuVisible"
      :evgSkuStatus="['Y']"
      multiple
      confirm-on-close
      reserve
      @confirm="chooseEvgSkuConfirm"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import CategoryCascader from '../category-cascader'
import ChooseEvgSku from '@/views/ecom/components/choose-evg-sku'
import SkuTable from './sku-table'
import { request } from '@/api/service'
import { add, multiply } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  components: { CategoryCascader, ChooseEvgSku, SkuTable },
  props: {
    evgCombineCode: { type: String, default: '' },
    evgCombineStatus: { type: String, default: '' },
    optType: { type: String, default: '' },
  },
  data() {
    return {
      formData: { ecomEvgCombinSkuList: [] },
      chooseEvgSkuVisible: false,
      rules: {
        combineName: [
          {
            required: true,
            message:
              this.$l('tips_input_combineName_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        combineNameEn: [
          {
            required: true,
            message:
              this.$l('tips_input_combineNameEn_placeholder') || '请输入...',
            trigger: 'blur',
          },
          // {
          //   validator: (rule, value, callback) => {
          //     const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
          //     if (!reg.test(value)) {
          //       callback()
          //     } else {
          //       callback(
          //         new Error(
          //           this.$l('form_placeholder_goodsNameEn_noChina') ||
          //             '英文名称不能存在中文'
          //         )
          //       )
          //     }
          //   },
          // },
        ],
        combinePattern: [
          {
            required: true,
            message:
              this.$l('tips_input_combinePattern_placeholder') || '请输入花型',
            trigger: 'blur',
          },
        ],
        combineColorCode: [
          {
            required: true,
            message: this.$l('tips_select_combineColor_data') || '请选择颜色',
            trigger: 'change',
          },
        ],
        combineColor: [
          {
            required: true,
            message: this.$l('tips_select_combineColor_data') || '请选择颜色',
            trigger: 'blur',
          },
        ],
        combineColorEn: [
          {
            required: true,
            message: this.$l('tips_select_combineColor_data') || '请选择颜色',
            trigger: 'blur',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('tips_select_cust_placeholder') || '请选择客户...',
            trigger: 'change',
          },
        ],
        brandCode: [
          {
            required: true,
            message: this.$l('tips_select_brand_data') || '请选择品牌...',
            trigger: 'change',
          },
        ],
        categoryCode: [
          {
            required: true,
            message: this.$l('tips_select_category') || '请选择品类...',
            trigger: 'change',
          },
        ],
      },
      brandOptions: [],
      seriesCustCodes: [],
      colorOptions: [],
    }
  },
  computed: {
    disabled() {
      return ['detail'].includes(this.optType)
    },
    brandOptionsMap() {
      return Object.fromEntries(this.brandOptions.map((o) => [o.value, o]))
    },
  },
  async mounted() {
    await this.getSeriesCustCodes()
    await this.getData()
    await this.getColor()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async getSeriesCustCodes() {
      const res = await this.$api
        .SYS_PARAMS_DETAIL({ paramID: 'SeriesCustCodes' })
        .catch(() => null)
      const { paramValue } = res?.body || {}
      this.seriesCustCodes = JSON.parse(paramValue || '[]')
    },
    async getColor() {
      request({
        url: '/ecom/amz/sku/dict/color',
        method: 'post',
      }).then((res) => {
        this.colorOptions = res.body.data
      })
    },
    async getData() {
      if (!this.evgCombineCode) return
      const res = await this.$api
        .ecomEvgCombineDetailApi({
          evgCombineCode: this.evgCombineCode,
        })
        .catch(() => null)
      if (!res) return
      const data = res.body
      this.formData = { ...data }
      const { evgCombineStatus } = data
      this.getBrandInfo()
      this.$emit('update:evgCombineStatus', evgCombineStatus)
    },
    async chooseEvgSkuConfirm(data) {
      if (!data || !data.length) return
      // 判断是否已经选中的数据
      const tableData = this.formData.ecomEvgCombinSkuList
      if (tableData?.length) {
        const findIndex = data.findIndex((item) => {
          return (
            tableData.findIndex((row) => item.evgSkuCode == row.evgSkuCode) >= 0
          )
        })
        if (findIndex >= 0) {
          this.$message.warning(
            this.$l('tip_label_duplicate_sku') ||
              '存在重复选中的SKU，已自动过滤！'
          )
        }

        data = data.filter((item) => {
          return (
            tableData.findIndex((row) => item.evgSkuCode == row.evgSkuCode) < 0
          )
        })
      }
      if (!data || !data.length) return
      data = data.map((item) => {
        const {
          evgSkuCode,
          goodsNameEn,
          goodsName,
          brandName,
          eanCode,
          colorCode,
          goodsColor,
          goodsColorEn,
          goodsPattern,
          goodsStyle,
          goodsSize,
        } = item
        return {
          ...item,
          uid: new Date().getTime(),
          evgSkuCode,
          combineName: goodsName,
          combineNameEn: goodsNameEn,
          eanCode: eanCode,
          brandCodeText: brandName,
          combineColorCode: colorCode,
          combineColor: goodsColor,
          combineColorEn: goodsColorEn,
          combinePattern: goodsPattern,
          combineStyle: goodsStyle,
          combineSize: goodsSize,
          inCombineQty: 1,
          isPrimary: 'N',
          isPrimaryText: '否',
        }
      })
      this.formData.ecomEvgCombinSkuList.push(...data)
      this.updateFtyPrice()
    },
    delRow(row) {
      const findIndex = this.formData.ecomEvgCombinSkuList.findIndex(
        (item) => item.evgSkuCode == row.evgSkuCode
      )
      if (findIndex > -1) {
        this.formData.ecomEvgCombinSkuList.splice(findIndex, 1)
      }
      this.updateFtyPrice()
    },
    async updateFormData(row) {
      const { ecomEvgCombinSkuList, ftyPrice } = this.formData
      this.formData = {
        ...row,
        ecomEvgCombinSkuList,
        ftyPrice,
      }
      await this.getSeriesCustCodes()
      await this.getBrandInfo()
      const evgSkuCode = row.evgSkuCode
      this.formData.ecomEvgCombinSkuList.forEach((e) => {
        if (e.evgSkuCode != evgSkuCode) {
          e.isPrimary = 'N'
          e.isPrimaryText = '否'
        }
      })
      // this.$refs.skuTable.reloadData(this.formData.ecomEvgCombinSkuList)
    },
    async updateFtyPrice() {
      const { ecomEvgCombinSkuList } = this.formData
      const ftyPrice = ecomEvgCombinSkuList.reduce(
        (result, next) =>
          add(result, multiply(next.inCombineQty, next.ftyPrice)),
        0
      )
      this.formData = { ...this.formData, ftyPrice }
    },
    async validate() {
      const formResult = await validate.formValidate([this.$refs.spuForm])
      const skuResult = await this.$refs.skuTable.validate()
      return formResult && skuResult
    },
    async save() {
      if (!(await this.validate())) return
      const { ecomEvgCombinSkuList } = this.formData
      if (!ecomEvgCombinSkuList || ecomEvgCombinSkuList.length <= 1) {
        this.$message.warning(
          this.$l('tip_label_sku_greater_than_one') ||
            '组合产品构成SKU须大于一个'
        )
        return
      }
      if (ecomEvgCombinSkuList && ecomEvgCombinSkuList.length > 1) {
        const isPrimaryList = ecomEvgCombinSkuList.filter(
          (item) => item.isPrimary === 'Y'
        )
        if (!isPrimaryList || isPrimaryList.length == 0) {
          this.$message.warning(
            this.$l('tip_combin_must_main_product') ||
              '组合产品构成须定义一个主产品'
          )
          return
        }
        if (isPrimaryList.length > 1) {
          this.$message.warning(
            this.$l('tip_combin_must_a_main_product') ||
              '组合产品构成只能定义一个主产品'
          )
          return
        }
      }
      this.loadingOpen()
      const res = await this.$api
        .ecomEvgCombineSaveApi({
          ...this.formData,
          evgCombineCode: this.evgCombineCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_save_combine_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_save_combine_ok') || '保存成功！',
        type: 'success',
      })

      const { evgCombineCode = '', evgCombineNo = '' } = body || {}
      if (this.optType === 'add' && evgCombineCode) {
        this.$router.replace({
          name: 'ecom-base-evgGoodsCombine-detail',
          params: { evgCombineCode, pageType: 'edit' },
          query: { evgCombineNo },
        })
        return
      }
      await this.getData()
    },

    changeCustCode() {
      this.brandOptions = []
      if (
        this.seriesCustCodes.includes(this.formData.custCode) ||
        !this.formData.custCode
      ) {
        this.formData = {
          ...this.formData,
          brandName: '',
          brandCode: '',
        }
      } else {
        this.formData = {
          ...this.formData,
          brandName: '',
          brandCode: '',
        }
      }

      this.getBrandInfo()
    },
    getBrandInfo() {
      this.brandOptions = []
      if (this.formData.custCode) {
        this.$api
          .ecomEvgSpuCustBrandSelectApi({
            custCode: this.formData.custCode,
          })
          .then((res) => {
            this.brandOptions = res?.body?.data || []
          })
      }
    },
    onChangeBrand(val) {
      if (val) {
        this.formData.brandName = this.brandOptionsMap[val].label
        this.formData = {
          ...this.formData,
          brandName: this.brandOptionsMap[val].label,
        }
      }
    },
    async colorChange(code) {
      if (!code) return
      const res = await request({
        url: '/ecom/amz/sku/dict/color/detail',
        method: 'POST',
        data: { colorCode: code },
      }).catch(() => null)
      if (!res) return
      const { colorName, colorNameEn } = res.body
      this.formData = {
        ...this.formData,
        combineColor: colorName,
        combineColorEn: colorNameEn,
      }
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.el-row {
  display: flex;
  align-items: stretch;
}
.image-col {
  padding: 0;
}
.image-wrapper {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
}
.text-col {
  padding: 0;
}
.text-wrapper {
  padding: 20px;
}
</style>
